/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getDpFanQuizPage = (_: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [],
		first: [{ name: 'DpFanQuiz', id: 'dp-fan-quiz' }],
		second: [],
		footer: [],
	},
});
